import React, { Component } from 'react'
import intl from 'react-intl-universal'
import { inject, observer, PropTypes } from 'mobx-react'
import { parse } from 'query-string'
import Page from './Page'
import Login from '../components/Login'

const BACKEND_AUTH_URL = 'https://auth.funoro.com'

@inject('user')
@observer
class NotAuthorisedPage extends Component {
  render () {
    return (
      <Page title='Information'>
        <article className='b-info'>
          <h2 className='b-info-title'>{intl.get('Login')}</h2>
          <h3 className='b-info-subtitle'>{intl.get('Only signed in user can see this page')}</h3>

          <Login />
        </article>
      </Page>
    )
  }
}

NotAuthorisedPage.propTypes = {
  location: PropTypes.objectOrObservableObject,
  user: PropTypes.observableObject
}

export default NotAuthorisedPage



// WEBPACK FOOTER //
// ./src/containers/NotAuthorisedPage.js